var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconWarningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.879 22.203l-11.95-19.98c-.18-.297-.688-.297-.868 0L.066 22.276a.474.474 0 000 .483c.09.149.256.241.433.241H24.5a.49.49 0 00.5-.482.468.468 0 00-.121-.315zM11.741 9.62c0-.103.072-.173.18-.173h1.148c.107 0 .178.07.178.173v6.976c0 .104-.07.173-.178.173H11.92c-.108 0-.18-.07-.18-.173V9.621zm1.543 9.972c0 .104-.073.172-.178.172h-1.22c-.108 0-.178-.07-.178-.172V18.33c0-.104.072-.172.178-.172h1.22c.107 0 .178.068.178.172v1.264z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconWarningFilled;